<template>
  <div class="animated fadeIn overflow-auto">
    <HeaderPadrao
      :titulo="registro.SEQUENCIA > 0 ? `Contas a Receber - ${registro.DOCUMENTO}` : 'CONTAS A RECEBER'"
      :subtitulo="registro.SEQUENCIA > 0 ? `Descrição: ${registro.ITENS}` : 'Cadastro de Títulos'"
      :icon="registro.SEQUENCIA > 0 ? 'fa fa-suitcase' : 'fa fa-plus-circle'"
    >
      <template #acoes>
        <b-button v-if="formok" variant="success" class="btn-glass mr-2" @click="post()">
          <i class="fa fa-save mr-1"></i> Gravar F10
        </b-button>
        <b-button variant="light" pill class="font-weight-bold shadow-sm" @click="voltar()">
          <i class="fa fa-arrow-left mr-1"></i> Voltar
        </b-button>
      </template>
    </HeaderPadrao>

    <div class="px-3">
      <!-- Barra de Resumo Premium -->
      <div class="row mb-4 mt-2">
        <div class="col-md-3">
          <div class="summary-card bg-gradient-primary shadow-sm">
            <div class="summary-body">
              <div class="summary-icon-wrapper">
                <i class="fa fa-file-text-o"></i>
              </div>
              <div class="summary-content">
                <span class="summary-label">Valor do Título</span>
                <h3 class="summary-value">R$ {{ (registro.VL_DOC || 0).toLocaleString('pt-BR', {minimumFractionDigits: 2}) }}</h3>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="summary-card bg-gradient-warning shadow-sm">
            <div class="summary-body">
              <div class="summary-icon-wrapper">
                <i class="fa fa-clock-o"></i>
              </div>
              <div class="summary-content">
                <span class="summary-label">Valor em Aberto</span>
                <h3 class="summary-value">R$ {{ (registro.VL_ARECEBER || 0).toLocaleString('pt-BR', {minimumFractionDigits: 2}) }}</h3>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="summary-card bg-gradient-success shadow-sm">
            <div class="summary-body">
              <div class="summary-icon-wrapper">
                <i class="fa fa-calendar-check-o"></i>
              </div>
              <div class="summary-content">
                <span class="summary-label">Vencimento</span>
                <h3 class="summary-value">{{ converterDataVencimento(registro.DT_RECEB) || '--/--/----' }}</h3>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="summary-card bg-gradient-info shadow-sm">
            <div class="summary-body">
              <div class="summary-icon-wrapper">
                <i class="fa fa-tag"></i>
              </div>
              <div class="summary-content">
                <span class="summary-label">Status</span>
                <h3 class="summary-value">{{ registro.STATUS || 'PENDENTE' }}</h3>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div style="max-height: 70vh; overflow-y: auto; overflow-x: hidden;" class="pr-2">
        <b-card no-body class="border-0 shadow-sm mb-4 rounded-lg">
          <div class="card-header bg-white border-bottom-0 py-3">
            <h5 class="mb-0 text-primary font-weight-bold">
              <i class="fa fa-info-circle mr-2"></i>Dados Principais
            </h5>
          </div>
          <b-card-body class="pt-0">
            <div class="row">
              <div class="col-sm-2">
                <b-form-group label="Código" label-class="font-weight-bold text-muted small text-uppercase">
                  <b-form-input type="text" id="ID" :disabled="true" class="rounded-pill bg-light border-0 shadow-xs" placeholder="Automático" v-model="registro.SEQUENCIA"></b-form-input>
                </b-form-group>
              </div>
              
              <div v-if="registro.SEQUENCIA > 0" class="col-sm-3">
                <b-form-group label="Data do Vencimento" label-class="font-weight-bold text-muted small text-uppercase">
                  <b-form-input type="date" id="ed_dtVencimento" class="rounded-pill shadow-xs" v-model="registro.DT_RECEB"></b-form-input>
                </b-form-group>
              </div>  

              <div class="col-sm-3">
                <b-form-group label="Data do Documento" label-class="font-weight-bold text-muted small text-uppercase">
                    <b-form-input type="date" id="ob_dtDocumento" class="rounded-pill shadow-xs" v-model="registro.DT_DOC" :state="!!registro.DT_DOC"></b-form-input>
                </b-form-group>
              </div>

              <div class="col-sm-4">
                <b-overlay :show="gerarDocumentoParametros.busy" rounded="lg" opacity="0.6" @hidden="onHidden_botaoGerarDocumento()">
                  <b-form-group label="Documento" label-class="font-weight-bold text-muted small text-uppercase">
                    <b-input-group>
                      <b-form-input type="text" id="ob_edDocumento" class="rounded-pill-left shadow-xs" v-model="registro.DOCUMENTO" :disabled="gerarDocumentoParametros.busy || desabilitado" :state="!!registro.DOCUMENTO" placeholder="Número do documento"></b-form-input>
                      <b-input-group-append>
                        <b-button v-if="!desabilitado" ref="bt_gerarDocumento" :disabled="gerarDocumentoParametros.busy" variant="primary" class="rounded-pill-right shadow-xs px-3" @click="onClick_botaoGerarDocumento()">
                          <i class="fa fa-magic mr-1"></i> Gerar
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-overlay>
              </div>
            </div>  
            
            <div class="row">
              <div class="col-sm-9">
                <b-form-group label="Descrição para o Relatório" label-class="font-weight-bold text-muted small text-uppercase">
                  <b-form-input type="text" id="edITENS" class="rounded-pill shadow-xs" v-model="registro.ITENS"  placeholder="Descrição min (3 letras)" :state="!!registro.ITENS"></b-form-input>
                </b-form-group>
              </div>
              <div class="col-sm-3">
                <b-form-group label="Tipo de documento" label-class="font-weight-bold text-muted small text-uppercase">
                  <b-form-select :plain="true" class="rounded-pill custom-select shadow-xs"  v-model="registro.OP_TIPO" :state="!!registro.OP_TIPO" :options="tipoOptions"></b-form-select>
                </b-form-group>
              </div>
            </div>

            <div class="row mt-2">
              <div class="col-sm-12 d-flex flex-wrap">
                <b-form-checkbox v-model="registro.OP_SOMENTE_DINHEIRO" value="1" unchecked-value="0" class="mr-4 mb-2 custom-checkbox-premium">
                  Somente Dinheiro
                </b-form-checkbox>
                <b-form-checkbox v-model="registro.OP_NAO_FLUXO_CAIXA" value="1" unchecked-value="0" class="mr-4 mb-2 custom-checkbox-premium">
                  Não Fluxo Caixa
                </b-form-checkbox>
                <b-form-checkbox v-model="registro.OP_GERA_JUROS" value="1" unchecked-value="0" class="mr-4 mb-2 custom-checkbox-premium">
                  Aplicar Juros
                </b-form-checkbox>
                <b-form-checkbox v-model="registro.OP_MULTA" value="1" unchecked-value="0" class="mr-4 mb-2 custom-checkbox-premium">
                  Aplicar Multa
                </b-form-checkbox>
                <b-form-checkbox v-model="registro.OP_DESCONTO" value="1" unchecked-value="0" class="mb-2 custom-checkbox-premium">
                  Aplicar Descontos
                </b-form-checkbox>
              </div>
            </div>
          </b-card-body>
        </b-card>
        <b-row>
          <b-col sm="6">
            <b-card no-body class="border-0 shadow-sm mb-4 rounded-lg h-100">
              <div class="card-header bg-white border-bottom-0 py-3">
                <h5 class="mb-0 text-primary font-weight-bold">
                  <i class="fa fa-users mr-2"></i>Interessados
                </h5>
              </div>
              <b-card-body class="pt-0">
                <div class="row">
                  <div class="col-sm-12 mb-3">
                    <cliente-pesquisa 
                      @retornaId="registro.COD_CLI = $event"
                      :idInicial="registro.COD_CLI"
                      :desabilitarInput="desabilitado"
                      ref="edCOD_CLI"
                      idModal="modalCliente"
                      :classe-required="true"
                      label="Cliente"
                      place="Informe o Cliente"
                      labelBotao=""
                      :arredondado="true">
                    </cliente-pesquisa>
                  </div>
                  <div class="col-sm-12 mb-3">
                    <b-form-group label="Vendedor" label-class="font-weight-bold text-muted small text-uppercase">
                      <vendedor-dropdown
                        v-model="registro.COD_VENDEDOR"
                        :disabled="desabilitado"
                        :placeholder="'Pesquise pelo nome do vendedor...'"
                        :state="!!registro.COD_VENDEDOR"
                        input-class="rounded-pill shadow-xs"
                      />
                    </b-form-group>
                  </div>
                  <div class="col-sm-12 mb-3">
                    <b-form-group label="Histórico - Plano de Contas" label-class="font-weight-bold text-muted small text-uppercase">
                      <historico-caixa-dropdown
                        v-model="registro.HISTORICO_ID"
                        
                        :placeholder="'Pesquise pelo nome do conferente...'"
                        :state="!!registro.HISTORICO_ID"
                        tipo='CREDITO'
                        input-class="rounded-pill shadow-xs"
                      />
                    </b-form-group>
                  </div>
                  <div class="col-sm-12">
                    <b-form-group label="Grupo a Receber" label-class="font-weight-bold text-muted small text-uppercase">
                      <grupo-areceber-dropdown
                        v-model="registro.COD_GRUPO"
                        
                        :placeholder="'Pesquise pelo nome do grupo...'"
                        :state="!!registro.COD_GRUPO"
                        input-class="rounded-pill shadow-xs"
                      />
                    </b-form-group>
                  </div>
                </div>
              </b-card-body>
            </b-card>
          </b-col>  

          <b-col sm="6" v-if="registro.SEQUENCIA <= 0">
            <b-card no-body class="border-0 shadow-sm mb-4 rounded-lg h-100">
              <div class="card-header bg-white border-bottom-0 py-3">
                <h5 class="mb-0 text-primary font-weight-bold">
                  <i class="fa fa-calculator mr-2"></i>Valores e Parcelamento
                </h5>
              </div>
              <b-card-body class="pt-0">
                <b-overlay :show="parcelamentoParametros.busy" rounded="lg" opacity="0.6" @hidden="onHidden_botaoParcelamento()">
                  <b-row>
                    <b-col sm="12">
                      <b-form-group label="Valor do Título" label-class="font-weight-bold text-muted small text-uppercase">
                        <vue-autonumeric v-model="parcelamentoParametros.valor" :options="'Brazilian'" id="ob_edValor" :class="['form-control rounded-pill shadow-xs', {'is-invalid': !parcelamentoParametros.valor}, {'is-valid': !!parcelamentoParametros.valor}]"></vue-autonumeric>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="6">
                      <b-form-group label="Parcelas" label-class="font-weight-bold text-muted small text-uppercase">
                        <b-form-select :plain="true" id="ob_comboVezes" class="rounded-pill custom-select shadow-xs" v-model="parcelamentoParametros.vez" :state="!!parcelamentoParametros.vez" :options="parcelamentoParametros.vezes"></b-form-select>
                      </b-form-group>
                    </b-col>
                    <b-col sm="6">
                      <b-form-group label="Data 1º Vencimento" label-class="font-weight-bold text-muted small text-uppercase">
                        <b-form-input type="date" id="ob_edPrimeiroVencimento" class="rounded-pill shadow-xs" v-model="parcelamentoParametros.dataPrimeira" :state="!!parcelamentoParametros.dataPrimeira"></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="12">
                      <b-form-group label="Dias entre Parcelas" label-class="font-weight-bold text-muted small text-uppercase">
                        <b-input-group>
                          <b-form-select :plain="true" class="rounded-pill-left custom-select shadow-xs" v-model="parcelamentoParametros.dia" :options="parcelamentoParametros.dias" :state="!!parcelamentoParametros.dias" :disabled="parcelamentoParametros.busy"></b-form-select>  
                          <b-input-group-append>
                            <b-button ref="bt_gerarParcelamento" :disabled="parcelamentoParametros.busy" variant="primary" class="rounded-pill-right shadow-xs px-3" @click="onClick_botaoParcelamento()">
                              <i class="fa fa-refresh mr-1"></i> Gerar
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <div class="mt-3">
                    <b-table 
                      striped 
                      hover 
                      show-empty
                      responsive
                      bordered
                      small
                      class="rounded shadow-sm overflow-hidden"
                      :dark="isDark"
                      head-variant="light"
                      empty-text="Não existe parcelamento"
                      :items="tabelaParcelamento.items" 
                      :fields="tabelaParcelamento.fields"
                      :tbody-tr-class="rowClassSelecionadoParcela"
                      @row-clicked="clicarLinhaParcela"
                      @row-dblclicked="abrirModalVencimento"
                    >
                      <template #cell(vencimento)="item">
                        {{ converterDataVencimento(item.item.vencimento) }}
                      </template>      
                    </b-table>
                  </div>
                </b-overlay>
              </b-card-body>
            </b-card>
          </b-col>  

          <b-col sm="6" v-else>
            <b-card no-body class="border-0 shadow-sm mb-4 rounded-lg h-100">
              <div class="card-header bg-white border-bottom-0 py-3 d-flex align-items-center justify-content-between">
                <h5 class="mb-0 text-primary font-weight-bold">
                  <i class="fa fa-balance-scale mr-2"></i>Ajustes - Juros e Descontos
                </h5>
                <b-button variant="success" size="sm" pill class="px-3 shadow-sm" @click="abrirModalAjusteAdd()">
                  <i class="fa fa-plus mr-1"></i> Adicionar
                </b-button>
              </div>
              <b-card-body class="pt-0">
                <b-table 
                  striped 
                  hover 
                  show-empty
                  responsive
                  bordered
                  small
                  class="rounded shadow-sm overflow-hidden"
                  :dark="isDark"
                  head-variant="light"
                  empty-text="Não existe ajuste"
                  :items="ajustes.items" 
                  :fields="ajustes.fields"
                  @row-dblclicked="abrirModalAjusteEdit"
                >
                  <template #cell(OP_TIPO)="item">
                    <b-badge pill :variant="colorirAjusteOP_TIPO(item.item.OP_TIPO)">{{traduzirAjusteOP_TIPO(item.item.OP_TIPO)}}</b-badge>
                  </template>
                  <template #cell(actions)="item">
                    <div class="text-center">
                      <b-button type="button" @click="deleteAjustes(item.item)" size="sm" variant="soft-danger" pill class="btn-action-pill" v-b-tooltip.hover="'Remover Ajuste'">
                        <i class="fa fa-trash-o"></i>
                      </b-button>
                    </div>
                  </template>
                </b-table>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>

        <b-row v-if="registro.SEQUENCIA > 0">
          <b-col sm="12">  
            <b-card no-body class="border-0 shadow-sm mb-4 rounded-lg h-100">
              <div class="card-header bg-white border-bottom-0 py-3">
                <h5 class="mb-0 text-primary font-weight-bold">
                  <i class="fa fa-line-chart mr-2"></i>Valores e Acompanhamento
                </h5>
              </div>
              <b-card-body class="pt-0">
                <div class="row">
                  <div class="col-sm-3">
                    <b-form-group label="Valor Original" label-class="font-weight-bold text-muted small text-uppercase">
                      <vue-autonumeric v-model="registro.VL_DOC" :options="'Brazilian'" disabled class="form-control text-right rounded-pill bg-light border-0 shadow-xs"></vue-autonumeric>
                    </b-form-group>
                  </div>
                  <div class="col-sm-3">
                    <b-form-group label="Recebimentos" label-class="font-weight-bold text-muted small text-uppercase">
                      <b-form-input class="text-right rounded-pill bg-light border-0 shadow-xs" v-model="recebimentos.somaTotalRecebido" disabled></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-sm-3">
                    <b-form-group label="Ajustes R$" label-class="font-weight-bold text-muted small text-uppercase">
                      <vue-autonumeric v-model="registro.VL_MULTA" :options="'Brazilian'" disabled class="form-control text-right rounded-pill bg-light border-0 shadow-xs"></vue-autonumeric>
                    </b-form-group>
                  </div>
                  <div class="col-sm-3">
                    <b-form-group label="Valor em Aberto" label-class="font-weight-bold text-muted small text-uppercase">
                      <vue-autonumeric v-model="registro.VL_ARECEBER" :options="'Brazilian'" disabled class="form-control text-right rounded-pill bg-light border-0 shadow-xs"></vue-autonumeric>
                    </b-form-group>
                  </div>
                </div>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>  
      </div>
    </div>
    
    <!-- MODAL VENCIMENTO -->
    <b-modal ref="modal-parcela" 
            id="modal-parcela" 
            size="md"
            centered
            no-close-on-esc
            no-close-on-backdrop
            hide-header-close
            @shown="focusModalParcela()" 
            header-class="modal-header-premium"
            body-class="p-4"
            footer-class="border-top-0 p-3"
            title="ALTERAR PARCELA">
            
      <template #modal-header>
        <div class="d-flex align-items-center justify-content-between w-100">
          <div class="d-flex align-items-center">
            <div class="header-icon-wrapper-modal mr-3">
              <i class="fa fa-pencil-square-o text-white"></i>
            </div>
            <div>
              <h5 class="modal-title text-white mb-0">Alterar Parcela</h5>
              <small class="text-white-50">Ajuste data e valor da parcela</small>
            </div>
          </div>
        </div>
      </template>
            
      <b-row class="mb-3">
        <b-col sm="12">
          <b-form-group label="Data de Vencimento" label-class="font-weight-bold text-muted small text-uppercase">
            <b-form-input type="date" id="edParcelamentoVENCIMENTO" ref="edParcelamentoVENCIMENTO" class="rounded-pill shadow-xs" v-model="tabelaParcelamento.item.vencimento" :state="!!tabelaParcelamento.item.vencimento"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <b-form-group label="Valor da Parcela" label-class="font-weight-bold text-muted small text-uppercase">
            <vue-autonumeric v-model="tabelaParcelamento.item.valor" :options="'Brazilian'" id="edParcelamentoVALOR" ref="edParcelamentoVALOR" :class="['form-control rounded-pill shadow-xs', {'is-invalid': !tabelaParcelamento.item.valor, 'is-valid': !!tabelaParcelamento.item.valor}]"></vue-autonumeric>
          </b-form-group>
        </b-col>
      </b-row>
    
      <template #modal-footer="{ cancel }">
        <b-button variant="soft-danger" class="rounded-pill px-4" @click="cancel()">
          <i class="fa fa-times mr-1"></i> Cancelar
        </b-button>
        <b-button variant="success" class="rounded-pill px-4" @click="editParcela(tabelaParcelamento.item)">
          <i class="fa fa-check mr-1"></i> Confirmar
        </b-button>
      </template>
    </b-modal>  

    <b-modal ref="modal-ajuste" 
            id="modal-ajuste" 
            size="lg"
            centered
            no-close-on-esc
            no-close-on-backdrop
            hide-header-close
            @shown="focusModalAjuste()" 
            header-class="modal-header-premium"
            body-class="p-4"
            footer-class="border-top-0 p-3"
            title="AJUSTES DE VALORES DO TITULO">

      <template #modal-header>
        <div class="d-flex align-items-center justify-content-between w-100">
          <div class="d-flex align-items-center">
            <div class="header-icon-wrapper-modal mr-3">
              <i class="fa fa-balance-scale text-white"></i>
            </div>
            <div>
              <h5 class="modal-title text-white mb-0">Ajustes de Valores</h5>
              <small class="text-white-50">Lançamento de juros, multas ou descontos</small>
            </div>
          </div>
        </div>
      </template>

      <div class="bg-light rounded-lg p-3 mb-4 border shadow-xs">
        <b-row class="mb-2">
          <b-col sm="3" class="text-muted small font-weight-bold text-uppercase">Cliente:</b-col>
          <b-col sm="9" class="font-weight-bold text-primary">{{ajustes.nomeCliente}}</b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col sm="3" class="text-muted small font-weight-bold text-uppercase">Documento:</b-col>
          <b-col sm="9" class="font-weight-bold">{{registro.DOCUMENTO}} - {{registro.PARCELA}}</b-col>
        </b-row>
        <b-row>
          <b-col sm="3" class="text-muted small font-weight-bold text-uppercase">Valor Atual:</b-col>
          <b-col sm="6" class="font-weight-bold text-success">R$ {{ (registro.VL_ARECEBER || 0).toLocaleString('pt-BR', {minimumFractionDigits: 2}) }}</b-col>
          <b-col sm="3" class="text-right">
            <b-badge pill :variant="colorirTipoMovimentacao(ajustes.registro.TIPO_MOVIMENTACAO_TITULO_ID)">{{traduzirTipoMovimentacao(ajustes.registro.TIPO_MOVIMENTACAO_TITULO_ID)}}</b-badge>
          </b-col>
        </b-row>
      </div>

      <b-row>
        <b-col sm="4">
          <b-form-group label="Valor" label-class="font-weight-bold text-muted small text-uppercase">
            <vue-autonumeric v-model="ajustes.registro.VALOR" :options="'Brazilian'" id="edAjustesVALOR" ref="edAjustesVALOR" :class="['form-control rounded-pill shadow-xs', {'is-invalid': !ajustes.registro.VALOR, 'is-valid': !!ajustes.registro.VALOR}]"></vue-autonumeric>
          </b-form-group>
        </b-col>
        <b-col sm="4">
          <b-form-group label="Tipo de Movimentação" label-class="font-weight-bold text-muted small text-uppercase">
            <b-form-select v-model="ajustes.registro.TIPO_MOVIMENTACAO_TITULO_ID" ref="edTipoMovimentacao" :options="ajustes.tipoMovimentacoes.options" :state="!!ajustes.registro.TIPO_MOVIMENTACAO_TITULO_ID" class="rounded-pill custom-select shadow-xs"></b-form-select>
          </b-form-group>
        </b-col>
        <b-col sm="4">
          <b-form-group label="Data" label-class="font-weight-bold text-muted small text-uppercase">
            <b-form-input type="date" id="edAjustesDATA" :state="!!ajustes.registro.DATA" v-model="ajustes.registro.DATA" class="rounded-pill shadow-xs"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col sm="12">
          <b-form-group label="Descrição" label-class="font-weight-bold text-muted small text-uppercase">
            <b-form-input type="text" id="edAjustesDESCRICAO" :state="!!ajustes.registro.DESCRICAO" placeholder="Informe a Descricao" v-model="ajustes.registro.DESCRICAO" class="rounded-pill shadow-xs"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col sm="12">
          <b-form-group label="Observação" label-class="font-weight-bold text-muted small text-uppercase">
            <b-form-textarea id="edAjustesOBSERVACAO" v-model="ajustes.registro.OBSERVACAO" placeholder="Opcional..." rows="3" class="rounded-lg shadow-xs"></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>

      <template #modal-footer="{ cancel }">
        <b-button variant="soft-danger" class="rounded-pill px-4" @click="cancel()">
          <i class="fa fa-times mr-1"></i> Cancelar
        </b-button>
        <b-button variant="success" class="rounded-pill px-4" @click="postAjustes()">
          <i class="fa fa-save mr-1"></i> Gravar Ajuste
        </b-button>
      </template>
    </b-modal>
    
  </div>
</template>

<script>
import VueButtonSpinner from '../../../components/VueButtonSpinner.vue'
import VendedorPesquisa from '../../pesquisa/VendedorPesquisa.vue'
import ClientePesquisa from '../../pesquisa/ClientePesquisa.vue'
import moment from 'moment'
import VueAutonumeric from 'vue-autonumeric'
import Tools from '@/tools/tools.js'
import VendedorDropdown from '../../componentes/dropdown/VendedorDropdown.vue'
import HistoricoCaixaDropdown from '../../componentes/dropdown/HistoricoCaixaDropdown.vue'
import FuncionarioDropdown from '../../componentes/dropdown/FuncionarioDropdown.vue'
import GrupoAreceberDropdown from '../../componentes/dropdown/GrupoAreceberDropdown.vue'
import HeaderPadrao from '@/components/Cec/HeaderPadrao.vue'


export default {
  components: {
    VueButtonSpinner,
    VendedorPesquisa,
    ClientePesquisa,
    VueAutonumeric,
    VendedorDropdown,
    HistoricoCaixaDropdown,
    FuncionarioDropdown,
    GrupoAreceberDropdown,
    HeaderPadrao
  },
  data () {
    return {
      formok: true,
      desabilitado: true,
      isLoading: false,
      status: '',
      registro: {
        SEQUENCIA                       : null,
        DOCUMENTO                       : null,
        EMPRESA                         : null,
        PARCELA                         : null,
        SEQ_VEN                         : null,
        DESCRICAO                       : null,
        TIPO_CLI                        : null,
        COD_CLI                         : null,
        COD_VENDEDOR                    : null,
        ITENS                           : null,
        COD_REPRES                      : null,
        COD_GRUPO                       : null,
        DT_DOC                          : null,
        DT_LANCAMENTO                   : null,
        DT_RECEB                        : null,
        FORMA                           : null,
        VL_DOC                          : null,
        VL_ARECEBER                     : null,
        VL_MULTA                        : null,
        DSC_MULTA                       : null,
        TIPO_COBRA                      : null,
        STATUS                          : null,
        OBS1                            : null,
        DOCREAL                         : null,
        OP_TIPO                         : null,
        OP_NAO_FLUXO_CAIXA              : null,
        OP_SOMENTE_DINHEIRO             : null,
        OP_GERA_MULTA                   : null,
        COD_BANCO                       : null,
        DT_CADASTRO                     : null,
        DT_ALTERACAO                    : null,
        CONTA_BOLETO_ID                 : null,
        SERIE                           : null,
        VALOR_BOLETO                    : null,
        VALOR_MORA_JUROS_BOLETO         : null,
        VALOR_DESCONTO_BOLETO           : null,
        VALOR_ABATIMENTO_BOLETO         : null,
        VALOR_MULTA_BOLETO              : null,
        NOSSO_NUMERO_COMPLETO           : null,
        NOSSO_NUMERO_SIMPLES            : null,
        BOLETO_IMPRESSO                 : null,
        BOLETO_REMESA                   : null,
        DATA_IMPRESSAO_BOLETO           : null,
        DATA_CADASTRO_BOLETO            : null,
        DATA_VENCIMENTO_BOLETO          : null,
        DATA_MULTA_JUROS_BOLETO         : null,
        DATA_ABATIMENTO_BOLETO          : null,
        DATA_DESCONTO_BOLETO            : null,
        DATA_PROTESTO_BOLETO            : null,
        DATA_REMESSA                    : null,
        USUARIO_CADASTRO_BOLETO         : null,
        USUARIO_IMPRESSAO_BOLETO        : null,
        INSTRUCAO1                      : null,
        INSTRUCAO2                      : null,
        OBSERVACOES_BOLETO              : null,
        PERCENTUAL_MORA_JUROS_BOLETO    : null,
        PERCENTUAL_DESCONTO_BOLETO      : null,
        PERCENTUAL_ABATIMENTO_BOLETO    : null,
        PERCENTUAL_MULTA_BOLETO         : null,
        BOLETO_ID                       : null,
        USUARIO_CADASTRO                : null,
        USUARIO_ALTERACAO               : null,
        OP_ORIGEM                       : null,
        PEDIDO_COMPRA_DESPESA_ID        : null,
        OBSERVACOES                     : null,
        EMBARQUE_REPRESENTA_DESPESA_ID  : null,
        CONTRATO_FLUXO_ID               : null,
        HISTORICO_ID                    : null,
        ABATE_ID                        : null,
        OP_GERA_JUROS                   : null,
        OP_DESCONTO                     : null,
        VALOR_DESCONTO                  : null,
        PERCENTUAL_JUROS                : null,
        VALOR_JUROS                     : null,
        VALOR_MORA                      : null,
        USUARIO_REPOSICAO               : null,
        DATA_CADASTRO                   : null,
        DATA_ALTERACAO                  : null,
        DATA_REPOSICAO                  : null,
        MOTIVO_REPOSICAO                : null,
        DATA_BAIXA                      : null,
        OBS_DESCONTO                    : null,
      },
      parcelamentoParametros: {
        submmited: false,
        value: 'Some value',
        busy: false,
        timeout: null,
        clicou: false,
        valor: 0,
        vez: 1,
        vezes: [],
        dia: 1,
        dias: [],
        ob_edValor: false,
        ob_edVezes: true,
        ob_edDias: true,
        dataPrimeira: new Date().toISOString().slice(0, 10)
      },
      gerarDocumentoParametros: {
        submmited: false,
        value: 'Some value',
        busy: false,
        clicou: false
      },
      tipoOptions: [
        { value: '0', text: 'Título' },
        { value: '1', text: 'Duplicata' },
        { value: '2', text: 'Boleto' },
        { value: '3', text: 'Promissória' },
        { value: '4', text: 'Cheque' },
        { value: '5', text: 'Outros' },
      ],
      tabelaParcelamento: {
        fields: [
          {
            key: "parcela",
            label: 'Parcela'
          },
          {
            key: 'vencimento',
            label: 'Vencimento',
            formatter: (value, key, item) => 
              moment(value).format("DD/MM/YYYY")
          },
          {
            key: 'valor', 
            class:'text-right', 
            label: 'Valor (R$)', 
            formatter: (value, key, item) => 
                value.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
          }
        ],
        items: [],
        parcelaSelecionada: null,
        itemSelecionado: {},
        item: {
          documento: null,
          observacao: null,
          vencimento: null,
          parcela: null,
          valor: null,
        }
      },
      recebimentos: {
        items: [],
        somaTotalRecebido: (0).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
      },
      ajustes: {
        nomeCliente: '',
        fields: [
          {
            key: 'ID',
            label: 'ID'
          },
          {
            key: 'DESCRICAO',
            label: 'Descrição'
          },
          {
            key: 'OP_TIPO',
            label: 'Tipo'
          },
          {
            key: 'DATA',
            class: 'text-right',
            label: 'Data',
            formatter: (value) => value ? moment(value).format('DD/MM/YYYY') : null
          },
          {
            key: 'VALOR',
            class: 'text-right',
            label: 'Valor (R$)',
            formatter: (value) => value ? value.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : null
          },
          {
            key: 'actions',
            label: 'Ações',
            class: 'text-right p-0 align-middle',
            thStyle: { width: '10% !important' }
          }
        ],
        items: [],
        registro: {
          ID: null,
          ARECEBER_ID: null,
          VALOR: null,
          DESCRICAO: null,
          DATA: null,
          DATA_CADASTRO: null,
          USUARIO_CADASTRO: null,
          DATA_ALTERACAO: null,
          USUARIO_ALTERACAO: null,
          DATA_EXCLUSAO: null,
          USUARIO_EXCLUSAO: null,
          SITUACAO: null,
          OBSERVACAO: null,
          TIPO_MOVIMENTACAO_TITULO_ID: null,
          DOCUMENTO: null,
          PARCELA: null,
        },
        tipoMovimentacoes: {
          options: [],
          items: []
        }
      },
         
      optionshistoricos: [],
      optionsGrupos: [],
      submmited: false
    }
  },
  
  computed: {
    isDark() {return this.$store.getters['tema/IS_DARK']  },
    
    tamanhocampoPagina () {
      if (this.registro.PAGINA) {
        return this.registro.PAGINA.length > 2 ? null : false
      }
      return false
    }
  },
  methods: {
    rowClassSelecionadoParcela(item, type) {
      if (type !== 'row' || !item) return ''
      
      const selId = this.tabelaParcelamento.parcelaSelecionada
      return item.parcela === selId ? 'cec-row-selected' : ''
      
    },
    clicarLinhaParcela(item) {
      this.tabelaParcelamento.parcelaSelecionada = item.parcela
    },
    converterDataVencimento(data) {
      return Tools.formatarDataBR(data)
    },
    abrirModalVencimento(item) {
      this.tabelaParcelamento.item = Tools.resetToNull(this.tabelaParcelamento.item, true)
      this.tabelaParcelamento.item = JSON.parse(JSON.stringify(item)) // deep clone
      this.tabelaParcelamento.itemSelecionado = item //usado para devolver os valores editados
      this.tabelaParcelamento.item.vencimento = Tools.formatarDataParaInput(this.tabelaParcelamento.item.vencimento)
      this.$refs['modal-parcela'].show()      
    },
    async editParcela() {
      if (!this.tabelaParcelamento.item.valor || this.tabelaParcelamento.item.valor <= 0) {
        Tools.exibirMensagem(this.$store, 'Erro', 'warning', `Valor da Parcela inválido` )
        return 
      }
      if (!this.tabelaParcelamento.item.vencimento ) {
        Tools.exibirMensagem(this.$store, 'Erro', 'warning', `Informe o vencimento` )
        return 
      }
      try {

        this.tabelaParcelamento.itemSelecionado.valor = this.tabelaParcelamento.item.valor
        this.tabelaParcelamento.itemSelecionado.vencimento = this.tabelaParcelamento.item.vencimento

        const soma = this.tabelaParcelamento.items.reduce((total, item) => {
          return total + (item.valor ?? 0) // usa 0 caso valor seja null/undefined
        }, 0)

        this.parcelamentoParametros.valor = soma
        
      } finally {
        this.$refs['modal-parcela'].hide()
        this.$store.commit('controle/setAguardando', false)
      }
    },
    voltar() {
      this.$router.push('/movimentos/contasreceber/listagem')
    },
    async somarRecebimentos() {
      try {
        const {data} = await this.$http.get(`/api/protected/recebido/listarrecebimentostitulo?documento=${this.registro.DOCUMENTO}&parcela=${this.registro.PARCELA}`)
        this.recebimentos.items = data
        const total = Array.isArray(data)
          ? data.reduce((valor, item) => valor + (parseFloat(item.VL_BAIXA) || 0), 0)
          : 0
        this.recebimentos.somaTotalRecebido = total.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Erro', 'warning', 'Não foi possível totalizar os recebimentos do título')
      }
    },
    async carregarAjustes() {
      try {
        const {data} = await this.$http.get('/api/protected/areceberAjuste/getByAreceberId/' + this.registro.SEQUENCIA)
        this.ajustes.items = data
      } catch (err) {
        throw err
      }
    },
    async carregarTiposMovimentacao() {
      try {
        const {data} = await this.$http.get('/api/protected/tipoMovimentacaoAreceber/listarTodos')
        this.ajustes.tipoMovimentacoes.options = [{value: null, text: ''}]
        this.ajustes.tipoMovimentacoes.items = data
        for (const tipo of data) {
          this.ajustes.tipoMovimentacoes.options.push({value: tipo.ID, text: `${tipo.ID} - ${tipo.DESCRICAO}`})
        }
      } catch (err) {
        throw err
      }
    },
    async abrirModalAjusteAdd() {
      if (!this.registro.SEQUENCIA) {
        Tools.exibirMensagem(this.$store, 'Erro', 'warning', 'É necessário gravar o título antes de lançar ajustes')
        return
      }
      try {
        await this.carregarTiposMovimentacao()
        this.ajustes.nomeCliente = this.$refs.edCOD_CLI?.$refs?.auto?.$refs?.autocomplete._value || ''
        Tools.resetToNull(this.ajustes.registro, true)
        this.ajustes.registro.ARECEBER_ID = this.registro.SEQUENCIA
        this.ajustes.registro.DOCUMENTO = this.registro.DOCUMENTO
        this.ajustes.registro.PARCELA = this.registro.PARCELA
        this.ajustes.registro.DATA = Tools.getDataAtual()
        this.$refs['modal-ajuste'].show()
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', `Não foi possível carregar a movimentação! ${err}`)
      }
    },
    async abrirModalAjusteEdit(item) {
      if (!item.ID || item.ID <= 0) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Selecione um registro válido')
        return
      }
      try {
        this.$store.commit('controle/setAguardando', true)
        await this.carregarTiposMovimentacao()
        this.ajustes.nomeCliente = this.$refs.edCOD_CLI?.$refs?.auto?.$refs?.autocomplete._value || ''
        const {data} = await this.$http.get(`/api/protected/areceberAjuste/getById/${item.ID}`)
        if (!data || data.length <= 0) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Registro não localizado')
          return
        }
        this.ajustes.registro = data[0]
        this.ajustes.registro.DATA = Tools.formatarDataParaInput(this.ajustes.registro.DATA)
        this.$refs['modal-ajuste'].show()
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', `Não foi possível carregar a movimentação! ${err}`)
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async postAjustes() {
      if (!this.ajustes.registro.VALOR || this.ajustes.registro.VALOR <= 0) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe o valor da movimentação')
        return
      }
      if (!this.ajustes.registro.TIPO_MOVIMENTACAO_TITULO_ID) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe o tipo da movimentação')
        return
      }
      if (!this.ajustes.registro.DESCRICAO || this.ajustes.registro.DESCRICAO.length < 3) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe a descrição da movimentação com no mínimo 3 letras')
        return
      }
      try {
        this.$store.commit('controle/setAguardando', true)
        const payloadAjustes = {
          login: window.localStorage.getItem('login'),
          registro: this.ajustes.registro
        }
        let data = null
        if (this.ajustes.registro.ID) {
          ({data} = await this.$http.put('/api/protected/areceberAjuste/edit', payloadAjustes))
          Tools.exibirMensagem(this.$store, 'Aviso', 'success', 'Movimentação alterada com sucesso!')
        } else {
          ({data} = await this.$http.post('/api/protected/areceberAjuste/post', payloadAjustes))
          Tools.exibirMensagem(this.$store, 'Aviso', 'success', 'Movimentação cadastrada com sucesso!')
        }
        this.ajustes.items = data.ajustes
        this.registro = Array.isArray(data.areceber) ? data.areceber[0] : data.areceber
        this.ajustarDados()
        await this.somarRecebimentos()
        this.$refs['modal-ajuste'].hide()
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', `Não foi possível gravar a movimentação! ${err.message || err}`)
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async deleteAjustes(item) {
      const msg = await this.$bvModal.msgBoxConfirm('Remover o ajuste lançado?', {
        title: 'Remover',
        size: 'sm',
        buttonSize: 'xl',
        okVariant: 'success',
        okTitle: 'SIM',
        cancelTitle: 'NÃO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true,
        noCloseOnEsc: true,
        noCloseOnBackdrop: true
      })

      if (!msg) return
      if (!item.ID) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Nenhum registro selecionado')
        return
      }
      try {
        this.$store.commit('controle/setAguardando', true)
        const payloadAjustes = {
          login: window.localStorage.getItem('login'),
          id: item.ID,
          documento: this.registro.DOCUMENTO,
          parcela: this.registro.PARCELA
        }
        const {data} = await this.$http.post('/api/protected/areceberAjuste/delete', payloadAjustes)
        this.ajustes.items = data.ajustes
        this.registro = data.areceber
        this.ajustarDados()
        await this.somarRecebimentos()
        Tools.exibirMensagem(this.$store, 'Aviso', 'success', 'Movimentação removida com sucesso!')
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', `Não foi possível remover a movimentação! ${err.message || err}`)
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    focusModalAjuste() {
      this.$nextTick(() => {
        this.$refs.edAjustesVALOR.$el.focus()
        this.$refs.edAjustesVALOR.$el.select()
      })
    },
    focusModalParcela() {
      this.$refs.edParcelamentoVENCIMENTO.focus()
    },
    onHidden_botaoParcelamento() {
      // Return focus to the button
      this.$refs.bt_gerarParcelamento.focus()
    },
    onClick_botaoParcelamento() {
      this.parcelamentoParametros.submmited = true
      this.parcelamentoParametros.busy = true
      this.gerarParcelamento()
    },
    onHidden_botaoGerarDocumento() {
      // Return focus to the button
      this.$refs.bt_gerarDocumento.focus()
    },
    async onClick_botaoGerarDocumento() {
      this.gerarDocumentoParametros.submmited = true
      this.gerarDocumentoParametros.busy = true
      try {
        const {data} = await this.$http.get( `/api/protected/areceber/getnovonumerodocumento`)
        this.registro.DOCUMENTO = data.id
      } catch(err) {
        console.log(err)
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', `Não foi possível gerar um numero! Tente novamente!!!`)
        return    
      } finally {
        this.gerarDocumentoParametros.busy = false
      }
      
    },
    async post () {
      if ( !this.registro.SEQUENCIA || this.registro.SEQUENCIA === null || this.registro.SEQUENCIA === undefined ) {
        await this.novo()
      } else {
        await this.editar()
      }
    },
    async novo () {

      if (!this.tabelaParcelamento.items || !this.tabelaParcelamento.length <= 0 ) {
        Tools.exibirMensagem(this.$store, 'Obrigatórios', 'warning', 'Informe o Lançamento das Parcelas. Mesmo se for apenas UMA!!!')
        return
      } 

      if (   (this.registro.DOCUMENTO == null )
          || (this.registro.OP_TIPO == null )
          || (this.registro.ITENS == null )
          || (this.registro.COD_CLI == null )
          || (this.registro.COD_VENDEDOR == null )
          || (this.registro.HISTORICO_ID == null )
          || (this.registro.COD_GRUPO  == null)) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', `Preencha todos os campos obrigatórios!!!`)
        return    
      }

      
      if (this.registro.SEQUENCIA || this.registro.SEQUENCIA > 0) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', `Operação Negada! O Título ja foi cadastrado!!!`)
        return    
      }
          
      let pacote = {
        registro : this.registro,
        parcelamento : this.tabelaParcelamento.items,
        login: window.localStorage.getItem('login')
      }
       try {
          this.$store.commit('controle/setAguardando', true)
          
          let {data} = await this.$http.post(`/api/protected/areceber/post`, pacote)
          const novoID = data.id
          this.$store.commit("areceber/SET_LIMPAR_APENAS_FILTRO", null)
          this.$store.commit("areceber/SET_REGISTRO_SELECIONADO_ID", novoID)
          this.$store.commit("areceber/SET_DOCUMENTO", this.registro.DOCUMENTO)
          await this.$store.dispatch('areceber/GERAR_LISTA')
          this.$store.commit("areceber/SET_DOCUMENTO", null)
  
          this.$router.push(`/movimentos/contasreceber/listagem`)
        
        }  catch(err) {
          Tools.exibirMensagem(this.$store, 'Erro', 'danger', err )
        } finally {
          this.$store.commit('controle/setAguardando', false)
  
        } 
    },
    async editar() {

     
      if (   (this.registro.SEQUENCIA == null )
          || (this.registro.DOCUMENTO == null )
          || (this.registro.OP_TIPO == null )
          || (this.registro.ITENS == null )
          || (this.registro.COD_CLI == null )
          || (this.registro.COD_VENDEDOR == null )
          || (this.registro.HISTORICO_ID == null )
          || (this.registro.COD_GRUPO  == null)) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', `Preencha todos os campos obrigatórios!!!`)
        return    
      }
     
  
      let pacote = {
        registro : this.registro,
        login: window.localStorage.getItem('login')
      }
          
      try {
        this.$store.commit('controle/setAguardando', true)
        
        let {data} = await this.$http.post(`/api/protected/areceber/edit`, pacote)
        this.$store.commit("areceber/SET_LIMPAR_APENAS_FILTRO", null)
        this.$store.commit("areceber/SET_REGISTRO_SELECIONADO_ID", this.registro.SEQUENCIA)
        this.$store.commit("areceber/SET_DOCUMENTO", this.registro.DOCUMENTO)
        await this.$store.dispatch('areceber/GERAR_LISTA')
        this.$store.commit("areceber/SET_DOCUMENTO", null)

        this.$router.push(`/movimentos/contasreceber/listagem`)
      
      }  catch(err) {
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', err )
      } finally {
        this.$store.commit('controle/setAguardando', false)

      } 
    },
    limparRegistro () {
      Tools.resetToNull(this.registro, true)

      this.registro.DESCRICAO = 'ARECEBER'
      this.registro.DT_DOC    = new Date().toJSON().slice(0, 10)
      this.registro.FORMA     = 'A PRAZO'
         

      this.parcelamentoParametros.submmited = false
      this.parcelamentoParametros.value = 'Some value'
      this.parcelamentoParametros.busy = false
      this.parcelamentoParametros.timeout = null
      this.parcelamentoParametros.clicou = false
      this.parcelamentoParametros.valor = 0.00
      this.parcelamentoParametros.vez = 1
      this.parcelamentoParametros.dia = 0
      this.parcelamentoParametros.dataPrimeira = new Date().toJSON().slice(0, 10)
      this.parcelamentoParametros.ob_edValor = false
      this.parcelamentoParametros.ob_edVezes = true
      this.parcelamentoParametros.ob_edDias = true
    },
    iniciarFormNovo () {
      this.limparRegistro()
      this.desabilitado = false
    },
    ajustarDados() {
      this.registro.DT_DOC = Tools.formatarDataParaInput(this.registro.DT_DOC)
      this.registro.DT_LANCAMENTO = Tools.formatarDataParaInput(this.registro.DT_LANCAMENTO)
      this.registro.DT_RECEB = Tools.formatarDataParaInput(this.registro.DT_RECEB)

    },
    async iniciarFormEditar ( id ) {
      try {
              
        this.limparRegistro()

        const {data} = await this.$http.get(`/api/protected/areceber/getbyid?id=${id}`)
        if (!data || data.length <= 0) {
          throw new Error('Registro não encontrado!')
        }
        
        this.registro = data[0]
        this.ajustarDados()
        await Promise.all([
          this.carregarAjustes(),
          this.somarRecebimentos()
        ])
      } catch (error) {
        console.log('Erro no iniciarFormEditar do ApagarCadastro')
        console.log(error)
        throw error  
      }
      
    },
    parcelar(){
      let auxVlParcela = this.parcelamentoParametros.valor / 
                                    this.parcelamentoParametros.vez
      let resto = auxVlParcela - (this.parcelamentoParametros.valor * this.parcelamentoParametros.vez);
      let vencimento = null
      this.tabelaParcelamento.items = []
      for (let i = 0; i < this.parcelamentoParametros.vez; i++) {
        //vencimento = this.somarData(this.parcelamentoParametros.dataPrimeira, parseInt( (this.parcelamentoParametros.dia) * i  )) 
        vencimento = moment(this.parcelamentoParametros.dataPrimeira).add((this.parcelamentoParametros.dia * (i + 1))  , 'days')
        this.tabelaParcelamento.items.push(
          {
            documento: '',
            observacao: 'PARCELAMENTO AVULSO',
            vencimento: vencimento,  
            parcela: i + 1,
            valor: auxVlParcela
          }
        )
      }
      this.parcelamentoParametros.busy = false
    },
    arredondar(valor) {
      return Number(valor.toFixed(2))
    },
    somarMeses(data, meses) {
      const d = new Date(data.getTime())
      const diaOriginal = d.getDate()
      d.setMonth(d.getMonth() + meses)

      // Corrige casos como 31 de janeiro + 1 mês => 3 de março
      if (d.getDate() < diaOriginal) {
        d.setDate(0) // vai para o último dia do mês anterior
      }

      return d
    },
    gerarParcelamento() {
      const parcelasInt = Math.round(this.parcelamentoParametros.vez)

      // Corrigir a data de entrada
      const baseData = new Date(`${this.parcelamentoParametros.dataPrimeira}T00:00:00`) // evita problemas de fuso
      
      const valorBase = this.arredondar(this.parcelamentoParametros.valor / parcelasInt)
      const totalBase = this.arredondar(valorBase * parcelasInt)
      const diferenca = this.arredondar(this.parcelamentoParametros.valor - totalBase) // pode ser centavos negativos

      this.tabelaParcelamento.items = []

      for (let i = 1; i <= parcelasInt; i++) {
        const vencimento = this.somarMeses(baseData, i)

        let valor = valorBase

        if (i === 1) {
          valor = this.arredondar(valorBase + diferenca) // soma o resto à primeira parcela
        }

        this.tabelaParcelamento.items.push({
          documento: '',
          vencimento: vencimento.toISOString().slice(0, 10), // data ISO
          parcela: i,
          valor: valor

        })
      }
      this.parcelamentoParametros.busy = false
    },
    prepararForm () {
      this.parcelamentoParametros.vezes = []
      for (let i = 1; i <= 60; i++) {
        this.parcelamentoParametros.vezes.push({value: i, text: i })
      }
      this.parcelamentoParametros.dias = []
      this.parcelamentoParametros.dias.push({
          value: 0,
          text: '0 Dias - Hoje'
      })
      for (let ii = 1; ii <= 60; ii++) {
        this.parcelamentoParametros.dias.push({
          value: ii,
          text: ii  + ' Dias'
        })
        
      }
    },
    async carregarHistoricos() {
      try {
        const {data} = await this.$http.get('api/protected/historico/listartodos')
        this.optionshistoricos = []
        let i
        for (i = 0; i < data.length; i++) {
          this.optionshistoricos.push({value: data[i].CODIGO, text: data[i].CODIGONOME})
        }
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possível carregar os historicos do caixa')
        return
      }
    },
    async carregarGrupos() {
      try {
        const {data} = await this.$http.get('api/protected/grupoareceber/listartodos')
        
        this.optionsGrupos = []
        let i
        for (i = 0; i < data.length; i++) {
          this.optionsGrupos.push({value: data[i].ID, text: data[i].CODIGONOME})
        }
       } catch (err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possível carregar os grupos')
        return
      }
    },
    colorirTipoMovimentacao(tipoMovimentacaoId) {
      const tipo = this.ajustes.tipoMovimentacoes.items.find(item => item.ID === tipoMovimentacaoId) || {}
      if (tipo.OP_TIPO === 'R') return 'danger'
      if (tipo.OP_TIPO === 'A') return 'success'
      return 'secondary'
    },
    traduzirTipoMovimentacao(tipoMovimentacaoId) {
      const tipo = this.ajustes.tipoMovimentacoes.items.find(item => item.ID === tipoMovimentacaoId) || {}
      if (tipo.OP_TIPO === 'R') return 'RETIRAR'
      if (tipo.OP_TIPO === 'A') return 'ACRESCENTAR'
      return 'INDISPONIVEL'
    },
    colorirAjusteOP_TIPO(opTipo) {
      if (opTipo === 'R') return 'danger'
      if (opTipo === 'A') return 'success'
      return 'secondary'
    },
    traduzirAjusteOP_TIPO(opTipo) {
      if (opTipo === 'R') return 'RETIRAR'
      if (opTipo === 'A') return 'ACRESCENTAR'
      return 'INDISPONIVEL'
    }
  },
  async created () {
    let id = this.$route.params.id
    const listas = [
      this.carregarHistoricos(),
      this.carregarGrupos()
    ]
    await Promise.all(listas)

    
    try {
      this.prepararForm()
      if ( id ) {
        await this.iniciarFormEditar( id )
      } else {
        this.iniciarFormNovo()
      }
    } catch (error) {
      console.log('Erro no created do AreceberCadastro')
      console.log(error)
      Tools.exibirMensagem(this.$store, 'Erro', 'danger', `Não foi possivel carregar o registro! ${error}` )
      this.formok = false
    }
  },
  watch: {
    'registro.SEQUENCIA': function () {
    }
  }
}
</script>


<style scoped>
.summary-card {
  border-radius: 15px;
  padding: 1.25rem;
  color: white;
  height: 100%;
  transition: transform 0.3s ease;
}

.summary-card:hover {
  transform: translateY(-5px);
}

.summary-body {
  display: flex;
  align-items: center;
}

.summary-icon-wrapper {
  background: rgba(255, 255, 255, 0.2);
  width: 50px;
  height: 50px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  margin-right: 1rem;
}

.summary-content {
  display: flex;
  flex-direction: column;
}

.summary-label {
  font-size: 0.75rem;
  text-transform: uppercase;
  font-weight: 600;
  opacity: 0.8;
  letter-spacing: 0.5px;
}

.summary-value {
  margin: 0;
  font-weight: 700;
  font-size: 1.25rem;
}

.bg-gradient-primary { background: linear-gradient(45deg, #4e73df 0%, #224abe 100%); }
.bg-gradient-success { background: linear-gradient(45deg, #1cc88a 0%, #13855c 100%); }
.bg-gradient-info { background: linear-gradient(45deg, #36b9cc 0%, #258391 100%); }
.bg-gradient-warning { background: linear-gradient(45deg, #f6c23e 0%, #dda20a 100%); }

.rounded-lg { border-radius: 1rem !important; }
.rounded-pill-left { border-top-left-radius: 50px !important; border-bottom-left-radius: 50px !important; }
.rounded-pill-right { border-top-right-radius: 50px !important; border-bottom-right-radius: 50px !important; }

.modal-header-premium {
  background: linear-gradient(135deg, #2c3e50 0%, #000000 100%) !important;
  padding: 1.5rem;
  border-bottom: 0;
}

.header-icon-wrapper-modal {
  width: 50px;
  height: 50px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
}

.btn-glass {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
}

.btn-soft-danger {
  background-color: rgba(248, 108, 107, 0.1);
  color: #f86c6b;
  border: none;
}

.btn-soft-danger:hover {
  background-color: #f86c6b;
  color: white;
}

.shadow-xs {
  box-shadow: 0 2px 4px rgba(0,0,0,0.05) !important;
}

.custom-checkbox-premium .custom-control-label::before {
  border-radius: 4px;
}

.custom-select.rounded-pill {
  padding-left: 1.25rem;
}

.cec-row-selected {
  background-color: rgba(78, 115, 223, 0.1) !important;
  font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/views/movimentos/contasreceber/AreceberCadastro.vue